var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value && _vm.value._id && _vm.value.label)?_c('div',[_c('div',{staticClass:"row align-center justify-center tournament-white--text italic px-2 caption",class:_vm.color,staticStyle:{"border-radius":"2px","height":"20px"}},[_vm._v("\n    "+_vm._s(_vm.$t(("enrollments.statuses." + (_vm.value._id))))+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46d2890e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Enrollments/Chip/index.vue
// module id = null
// module chunks = 